import CarImages from '@components/image-export-gallerie/CarImages';
import { PageHeader } from '@components/page-header';
import { PageMeta } from '@components/page-meta';
import PageContainer from '@components/PageContainer';
import { Link, Typography, makeStyles } from '@material-ui/core';
import { useParams } from '@reach/router';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useApi from 'src/hooks/useApi';
import ApiService from 'src/modules/api-service';

import { DetailCarDTO } from '../../modules/generated/api/api';

type ImageExportPageParams = {
  vin: string;
};

const useStyles = makeStyles((theme) => ({
  pageHeader: {
    marginBlockEnd: theme.spacing(4.5),
  },
  verticalCenter: {
    verticalAlign: 'middle',
  },
}));

export const ImageExport = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { vin } = useParams<ImageExportPageParams>();
  const [carData, setCarData] = useState<DetailCarDTO | null>(null);
  const { fetch } = useApi();

  useEffect(() => {
    const fetchCarData = async (): Promise<void> => {
      try {
        const response = await fetch(ApiService.listCars.listCarsControllerDetailByVin(vin));

        if (response?.status !== 200) {
          throw new Error(`HTTP error! status: ${response?.status}`);
        }

        const data: DetailCarDTO = (await response.data) as DetailCarDTO;
        setCarData(data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching car data:', error);
      }
    };

    if (vin) {
      fetchCarData();
    }
  }, [fetch, vin]);

  return (
    <>
      <PageMeta title={t('imageExport.title')} />
      <PageContainer>
        <PageHeader
          className={classes.pageHeader}
          headline={
            <>
              {t('imageExport.pageHeader.headline')}{' '}
              <Typography component="span" className={classes.verticalCenter}>
                {vin}
              </Typography>
            </>
          }
          body={
            <>
              {t('imageExport.pageHeader.body')}{' '}
              <Link href="mailto:alluc@porsche.co.at" target="_blank">
                alluc@porsche.co.at
              </Link>
            </>
          }
        />

        <CarImages vin={vin} car={carData} />
      </PageContainer>
    </>
  );
};

export default ImageExport;
